import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SideGallery from '../../components/SideGallery';
import { PageRoutes } from '../../page-routes';
import { DateTime } from 'luxon';
import { IPlaylistDataDto } from '../../clients/services';
import { PlaylistPublicService } from '../../services';

const playlistPublicService = new PlaylistPublicService();

export const PlaylistPreview = () => {
    const [newestPlaylist, setNewestPlaylist] = useState<IPlaylistDataDto | null>(null);

    useEffect(() => {
        const loadNewest = async () => {
            try {
                const playlist = await playlistPublicService.loadNewestPlaylistAsync();
                setNewestPlaylist(playlist);
            } catch {
                setNewestPlaylist(null);
            }
        };

        loadNewest();
    }, []);

    if (!newestPlaylist) {
        return null;
    }

    const images = [];
    if (newestPlaylist.image) {
        images.push({
            link: playlistPublicService.resolveImageUrl(newestPlaylist.image),
            title: newestPlaylist.playlist[0].artist + ' - ' + newestPlaylist.playlist[0].title,
        });
    }
    return (
        <SideGallery images={images} title="Martin's Playlist">
            <>
                <p>
                    Hier stelle ich euch jeweils ein paar meiner aktuellen Music-Hits vor. Ihr findet darunter immer
                    wieder h&ouml;renswerte (Geheim-)Tipps!
                    <br />
                </p>
                <p>&nbsp;</p>
                <NavLink to={PageRoutes.Playlists}>
                    Playlist,{' '}
                    {DateTime.fromObject({ year: newestPlaylist.year, month: newestPlaylist.month }).toFormat('LLLL')}{' '}
                    {newestPlaylist.year}
                </NavLink>
            </>
        </SideGallery>
    );
};

export default PlaylistPreview;
